import { render, staticRenderFns } from "./topCom.vue?vue&type=template&id=0a44cfbe&scoped=true&"
import script from "./topCom.vue?vue&type=script&lang=ts&"
export * from "./topCom.vue?vue&type=script&lang=ts&"
import style0 from "./topCom.vue?vue&type=style&index=0&id=0a44cfbe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a44cfbe",
  null
  
)

export default component.exports